/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import AvatarShape from './AvatarShape';
import DeltaShape from './DeltaShape';

const UserShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  title: PropTypes.string,
  description: DeltaShape,
  email: PropTypes.string,
  type: PropTypes.oneOf(['ADMIN', 'GUEST', 'USER', 'BOT']),
  avatar: AvatarShape,
  settings: PropTypes.object,
  identities: PropTypes.arrayOf(PropTypes.object),
  deactivatedAt: PropTypes.string,
  insertedAt: PropTypes.string,
  updatedAt: PropTypes.string,
  contributedTopics: PropTypes.arrayOf(PropTypes.object),
  sharedPosts: PropTypes.arrayOf(PropTypes.object),
});

export default UserShape;
